module.exports = __webpack_public_path__ + "static/media/ginarogershistoricalmovement.8456bec9.svg";